module.exports = __webpack_public_path__ + "489001754d487b9e04ba6ecab0a9a50e.png";